/**
 * D6BattleActionType - Action de combat D6
 * Gère les jets de dés et calcule les dégâts
 */

import {ActionType} from '../../types/ActionType';
import {GameState} from '../../../models/GameState';
import {PlayerStep} from '../../../models/PlayerStep';
import {PlayerNotification} from '../../../models/PlayerNotification';
import GameStateHelper from '../../../helpers/GameStateHelper';

export class D6BattleActionType implements ActionType {
  typeName = 'battle';

  async execute(
    gameState: GameState,
    currentStep: PlayerStep,
    params?: {[key: string]: any},
  ): Promise<PlayerNotification[]> {
    console.log('[D6BattleActionType] execute called with params:', params);

    // Récupérer les valeurs des dés
    const playerDice1 = params?.player_dice1 || 0;
    const playerDice2 = params?.player_dice2 || 0;
    const opponentDice1 = params?.opponent_dice1 || 0;
    const opponentDice2 = params?.opponent_dice2 || 0;

    console.log('[D6BattleActionType] Player dice:', playerDice1, playerDice2);
    console.log('[D6BattleActionType] Opponent dice:', opponentDice1, opponentDice2);

    // Récupérer les caractéristiques du joueur
    const playerForceField = GameStateHelper.getAdventureExtraField(gameState, 'D6_FORCE');
    const playerDamageField = GameStateHelper.getAdventureExtraField(gameState, 'D6_DAMAGE');
    const playerLifeField = GameStateHelper.getAdventureExtraField(gameState, 'D6_PV');

    const playerForce = this.parseValue(playerForceField?.currentValue);
    const playerDamage = this.parseValue(playerDamageField?.currentValue);
    let playerLife = this.parseValue(playerLifeField?.currentValue);

    console.log('[D6BattleActionType] Player - Force:', playerForce, 'Damage:', playerDamage, 'Life:', playerLife);

    // Récupérer les caractéristiques de l'ennemi
    const enemyForceField = GameStateHelper.getStepExtraField(gameState, currentStep.numero, 'D6_FORCE_MONSTER');
    const enemyDamageField = GameStateHelper.getStepExtraField(gameState, currentStep.numero, 'D6_DAMAGE_MONSTER');
    const enemyLifeField = GameStateHelper.getStepExtraField(gameState, currentStep.numero, 'D6_PV_MONSTER');

    const enemyForce = this.parseValue(enemyForceField?.currentValue);
    const enemyDamage = this.parseValue(enemyDamageField?.currentValue);
    let enemyLife = this.parseValue(enemyLifeField?.currentValue);

    console.log('[D6BattleActionType] Enemy - Force:', enemyForce, 'Damage:', enemyDamage, 'Life:', enemyLife);

    // Calculer les totaux
    const playerTotal = playerDice1 + playerDice2 + playerForce;
    const enemyTotal = opponentDice1 + opponentDice2 + enemyForce;

    console.log('[D6BattleActionType] Player total:', playerTotal, 'Enemy total:', enemyTotal);

    const notifications: PlayerNotification[] = [];

    // Déterminer le vainqueur et appliquer les dégâts
    if (playerTotal > enemyTotal) {
      // Le joueur gagne - l'ennemi perd des PV
      enemyLife = Math.max(0, enemyLife - playerDamage);
      
      if (enemyLifeField) {
        GameStateHelper.updateGameStateStepExtraFieldValue(gameState, enemyLifeField, enemyLife.toString());
      }

      console.log('[D6BattleActionType] Player wins! Enemy loses', playerDamage, 'HP. New enemy HP:', enemyLife);

      notifications.push({
        title: 'Touché !',
        description: `L'adversaire perd ${playerDamage} PV.`,
        isCheat: false,
      });

      // Vérifier si l'ennemi est vaincu
      if (enemyLife <= 0) {
        notifications.push({
          title: 'Victoire !',
          description: 'Vous avez vaincu votre adversaire !',
          isCheat: false,
        });
      }
    } else if (enemyTotal > playerTotal) {
      // L'ennemi gagne - le joueur perd des PV
      playerLife = Math.max(0, playerLife - enemyDamage);
      
      if (playerLifeField) {
        GameStateHelper.updateGameStateAdventureExtraFieldValue(gameState, playerLifeField, playerLife.toString());
      }

      console.log('[D6BattleActionType] Enemy wins! Player loses', enemyDamage, 'HP. New player HP:', playerLife);

      notifications.push({
        title: 'Raté !',
        description: `Vous perdez ${enemyDamage} PV.`,
        isCheat: false,
      });

      // Vérifier si le joueur est vaincu
      if (playerLife <= 0) {
        gameState.state = 'FAILED';
        notifications.push({
          title: 'Défaite...',
          description: 'Vous n\'avez plus de points de vie !',
          isCheat: false,
        });
      }
    } else {
      // Égalité - aucun dégât
      console.log('[D6BattleActionType] Draw! No damage.');
      
      notifications.push({
        title: 'Égalité !',
        description: 'Aucun dégât infligé.',
        isCheat: false,
      });
    }

    return notifications;
  }

  private parseValue(value: string | number | null | undefined): number {
    if (value === null || value === undefined) return 0;
    if (typeof value === 'number') return value;
    const intValue = parseInt(String(value), 10);
    return isNaN(intValue) ? 0 : intValue;
  }
}
